var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageCircle = function SvgImageCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 42c11.046 0 20-8.954 20-20S35.046 2 24 2 4 10.954 4 22s8.954 20 20 20Z",
    stroke: "#fff",
    strokeWidth: 2.268,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 12H16a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2ZM21.096 24.76l2.146 3.112 3.185-7.351a1 1 0 0 1 1.81-.055L32 27.88V14H16v15.76l3.45-5a1 1 0 0 1 1.646 0ZM21 22a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm1-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5.416 4.269L30.833 30H24.5l2.916-6.731Zm-7.143 3.82L22.28 30h-4.016l2.009-2.911Z",
    fill: "#fff"
  })));
};
export default SvgImageCircle;